/**
 * Route map. Two portals share one bundle:
 *   /sme/*  subject-matter experts (dashboard, guide, new/edit draft, task detail)
 *   /eng/*  engineers (dashboard, all tasks, task review, SMEs, docs)
 */
import { Navigate, Route, Routes } from 'react-router-dom'
import { RequireReviewer } from './auth/RequireReviewer'
import { RequireRole } from './auth/RequireRole'
import { Layout } from './components/Layout'
import { ThemeProvider } from './components/ThemeProvider'
import Landing from './pages/Landing'
import AuthPage from './pages/AuthPage'
import SmeDashboard from './pages/sme/Dashboard'
import { TaskDirectory, DirectoryTask } from './pages/sme/TaskDirectory'
import SmeGuide from './pages/sme/Guide'
import SmeSubmit from './pages/sme/Submit'
import SmeTaskDetail from './pages/sme/TaskDetail'
import SmeReviews from './pages/sme/Reviews'
import SmeReview from './pages/sme/Review'
import SmeProfile from './pages/sme/Profile'
import IntroductionExample from './pages/sme/IntroductionExample'
import EngDashboard from './pages/eng/Dashboard'
import EngTasks from './pages/eng/Tasks'
import EngTaskReview from './pages/eng/TaskReview'
import EngSmes from './pages/eng/Smes'
import EngDocs from './pages/eng/Docs'
import EngRuns from './pages/eng/Runs'
import EngNewRun from './pages/eng/NewRun'
import EngRunDetail from './pages/eng/RunDetail'
import EngTaskRuns from './pages/eng/TaskRuns'
import EngAgents from './pages/eng/Agents'
import EngRemi from './pages/eng/Remi'
import TemplateIntake from './pages/scientific/TemplateIntake'

export default function App() {
  return (
    <ThemeProvider><Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Landing />} />

      <Route path="/sme/login" element={<Landing />} />
      <Route path="/sme/signup" element={<AuthPage role="sme" mode="signup" />} />
      <Route path="/eng/login" element={<Landing />} />
      <Route path="/eng/signup" element={<AuthPage role="engineer" mode="signup" />} />

      <Route element={<RequireRole role="sme" />}>
        <Route element={<Layout role="sme" />}>
          <Route path="/sme" element={<SmeDashboard />} />
          <Route path="/sme/task-directory" element={<TaskDirectory />} />
          <Route path="/sme/task-directory/:taskId" element={<DirectoryTask />} />
          <Route element={<RequireReviewer />}>
            <Route path="/sme/reviews" element={<SmeReviews />} />
            <Route path="/sme/reviews/:taskId/:roundId" element={<SmeReview />} />
          </Route>
          <Route path="/sme/guide" element={<SmeGuide />} />
          <Route path="/sme/profile" element={<SmeProfile />} />
          <Route path="/sme/introduction/example" element={<IntroductionExample />} />
          <Route path="/sme/templates/:templateId" element={<TemplateIntake />} />
          <Route path="/sme/submit" element={<SmeSubmit />} />
          <Route path="/sme/tasks/:taskId" element={<SmeTaskDetail />} />
          <Route path="/sme/tasks/:taskId/edit" element={<SmeSubmit />} />
        </Route>
      </Route>

      <Route element={<RequireRole role="engineer" />}>
        <Route element={<Layout role="engineer" />}>
          <Route path="/eng" element={<EngDashboard />} />
          <Route path="/eng/templates/:templateId" element={<TemplateIntake developer />} />
          <Route path="/eng/tasks" element={<EngTasks />} />
          <Route path="/eng/tasks/:taskId" element={<EngTaskReview />} />
          <Route path="/eng/runs" element={<EngRuns />} />
          <Route path="/eng/runs/new" element={<EngNewRun />} />
          <Route path="/eng/runs/tasks/:taskId" element={<EngTaskRuns />} />
          <Route path="/eng/runs/:runId" element={<EngRunDetail />} />
          <Route path="/eng/agents" element={<EngAgents />} />
          <Route path="/eng/agents/messages" element={<EngAgents />} />
          <Route path="/eng/agent-messages" element={<Navigate to="/eng/agents/messages" replace />} />
          {/* The detail is a panel over the board, but it keeps a URL so it can be linked. */}
          <Route path="/eng/agents/:taskId/:jobId" element={<EngAgents />} />
          <Route path="/eng/remi" element={<EngRemi />} />
          <Route path="/eng/smes" element={<EngSmes />} />
          <Route path="/eng/requests" element={<Navigate to="/eng/tasks" replace />} />
          <Route path="/eng/docs" element={<EngDocs />} />
        </Route>
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes></ThemeProvider>
  )
}
